import translateFunction from "../translations/translationMain.js";
import useColors from "../customHooks/useColors.js";

//BaseParagraph -> |

const BaseParagraph = (props) => {
  ////////////////////////////////////////////////////////destructured props
  const {
    translate = true,
    bold = false,
    italic = false,
    style = {}, //ide na span
    children = undefined,
    onClick = () => {},
    className = null,
    innerRef = null,
  
  } = props;

  ////////////////////////////////////////////////////////current theme
  const [currentColors] = useColors();

  ////////////////////////////////////////////////////////current lang

  const vParagraphText = translate
    ? translateFunction({ key: children })
    : children;

  ////////////////////////////////////////////////////////styles
  const styles = {
    mainParagraph: {
      color: currentColors.tertiary,
      marginBottom: 0,
      fontWeight: bold ? 600 : 400,
      fontStyle: italic ? "italic" : "normal",
    },
  };

  ////////////////////////////////////////////////////////render
  return (
    <>
      <span
        ref={innerRef}
        className={className}
        onClick={onClick}
        style={{ ...styles.mainParagraph, ...style }}
      >
        {vParagraphText}
      </span>
    </>
  );
};

export default BaseParagraph;
